var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('section',[_c('h3',[_vm._v("营销日历")])]),_c('section',[_c('h3',[_vm._v("商品销量排行")])]),_c('section',[_c('h3',[_vm._v("销售金额排行")])])])
}]

export { render, staticRenderFns }